import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { closeBtn, dialogActions, dialogTitle, paperProps, title } from './TemplateModals.sx';
import CloseIcon from 'app/components/Icons/CloseIcon';
import SuccessModal from 'app/components/SuccessModal';
import CustomInput from 'app/components/CustomInput';
import logger from 'app/utils/logger';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  templateName: string;
  id?: any;
  changeNameTemplate?: any;
  data?: any;
  dataChangeName?: any;
  error?: boolean;
  setError?: any;
}

const NameChangeModal = (props: Props) => {
  const { open, close, templateName, changeNameTemplate, id, data, dataChangeName, error, setError } = props;
  const [successModal, setSuccessModal] = useState(false);
  const [name, setName] = useState(templateName);

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => close(false)}
      >
        <DialogTitle sx={{ ...dialogTitle, mb: '28px' }}>
          <Typography sx={title}>Şablonun adnı dəyiş</Typography>
          <Button
            color={'tertiary'}
            onClick={() => {
              close(false);
              setError(false);
            }}
            sx={closeBtn}
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <DialogContent sx={{ pl: '40px' }}>
          <CustomInput
            title={'Şablonun adı'}
            value={name}
            handleChange={(e: any) => {
              setName(e.target.value);
            }}
            isValid={error}
            errorText={'Qeyd edilən ad ilə şablon artıq mövcuddur'}
          />
        </DialogContent>
        <DialogActions sx={dialogActions}>
          <Button
            onClick={() => {
              // close(false);
              changeNameTemplate({
                ...data,
                id,
                title: name,
              });
            }}
            disabled={name.length === 0}
          >
            Yadda saxla
          </Button>
          <Button
            color={'secondary'}
            sx={{ ml: '0 !important' }}
            onClick={() => {
              close(false);
              setError(false);
            }}
          >
            İmtina
          </Button>
        </DialogActions>
      </Dialog>
      <SuccessModal open={successModal} close={setSuccessModal} successText={'Dəyişiklər uğurla yadda saxlanıldı!'} />
    </>
  );
};

export default NameChangeModal;
